<!DOCTYPE html
  PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" lang="it" style="height: auto;">

<head id="Head1">
  <!-- INIZIO META TAG PER IDENTIFICAZIONE E MOTORI DI RICERCA -->
  <meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1" />
  <title>
    Telefoni e indirizzi - Regione Emilia-Romagna
  </title>
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="description" content="Telefoni e indirizzi" />
  <meta http-equiv="X-UA-Compatible" content="IE=Edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/bootstrap/v3.3.7/css/bootstrap.min.css" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/designer-italia/designer-italia-legacy.css" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/designer-italia/designer-italia-styleguide.css" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/designer-italia/build.css" />
  <link rel="stylesheet" href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/er.css" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/styles.css" />
  <link rel="stylesheet" href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/-siti/Site.css" />
  <link rel="stylesheet"
    href="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/fontawesome/v5.3.1/css/all.css" />
  <link rel="shortcut icon" type="image/x-icon" href="https://www.regione.emilia-romagna.it/favicon.ico" />

  <script defer
    src="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/fontawesome/v5.3.1/js/all.js"></script>
  <script defer
    src="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/fontawesome/v5.3.1/js/v4-shims.js">
  </script>
</head>

<body>
  <div id="visual-portal-wrapper">
    <script type="text/javascript">
      var x = document.getElementsByTagName("body");
      var i;
      for (i = 0; i < x.length; i++) {
        x[i].className = "t-Pac c-hideFocus enhanced";
      }

      var v_piwikSiteId;

    </script>

    <footer class="Footer">
      <div class="u-layout-wide u-layoutCenter u-layout-r-withGutter">
        <div class="u-cf">
          <img src="https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/marchio-rer-w.png"
            alt="Regione Emilia-Romagna" class="image-inline" id="logo-footer">
          <p class="Footer-siteName"></p>
        </div>
        <div class="Grid Grid--withGutter">
          <div class="Footer-block Grid-cell u-md-size1of3 u-lg-size1of3">
            <h2 class="Footer-subTitle">Recapiti</h2>
            <p><strong>Regione Emilia-Romagna</strong><br>Viale Aldo Moro, 52<strong><br></strong>40127
              Bologna<br><strong>Centralino</strong> <a href="tel:+39.0515271">051 5271</a><br><a class="external-link"
                href="https://wwwservizi.regione.emilia-romagna.it/Cercaregione/Default.aspx?cons=0">Cerca
                telefoni o indirizzi</a>&nbsp;</p>
          </div>
          <div class="Footer-block Grid-cell u-md-size1of3 u-lg-size1of3">
            <h2 class="Footer-subTitle"><span title="Ufficio relazioni con il pubblico">URP</span></h2>
            <p><strong>Sito web: </strong><a
                href="https://www.regione.emilia-romagna.it/urp/">www.regione.emilia-romagna.it/urp</a>
              <br>
              <strong>Numero verde:</strong> <a class="list-item" href="tel:+39.800662200">800.66.22.00</a>
              <br>
              <strong>Scrivici:</strong>
              <a class="list-item" href="mailto:urp@regione.emilia-romagna.it">e-mail</a> - <a class="list-item"
                href="mailto:urp@postacert.regione.emilia-romagna.it">PEC</a>
          </div>
          <div class="Footer-block Grid-cell u-md-size1of3 u-lg-size1of3">
            <h2 class="Footer-subTitle">Trasparenza</h2>
            <div class="link-list-wrapper">
              <ul class="footer-list link-list clearfix">
                <li><a href="https://trasparenza.regione.emilia-romagna.it/">Amministrazione trasparente</a></li>
                <li><a href="https://www.regione.emilia-romagna.it/note-legali">Note legali e copyright</a></li>
                <li><a href="https://www.regione.emilia-romagna.it/privacy">Privacy e Cookies</a></li>
                <li><a href="https://www.regione.emilia-romagna.it/accessibilita">Dichiarazione di
                    accessibilit&agrave;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <script type="text/javascript">
      //<![CDATA[
      var aElements = document.getElementsByTagName("a");
      for (i = 0; i < aElements.length; i++) {
        //debugger;
        if (aElements[i].attributes.getNamedItem("rel") && aElements[i].rel == "linkbutton") {
          aElements[i].className = aElements[i].className.replace("nascosto", "");
        }
      }
      //]]>

    </script>
  </div>
</body>

</html>
